const isLocalDevelopment = process.env.NODE_ENV === 'development';

const hmlHosts = [
  'homologacao.aqila.com.br',
  'testesqa.aqila.com.br',
  'testesdetox.aqila.com.br',
  // 'staging.aqila.com.br', // Staging fica fora para ser um "contra-teste"
];

const releaseCandidateHosts = [
  'rc.aqila.com.br',
  'rc-sinc-rabbit.aqila.com.br',
];

const allowedHostsForV2 = [
  ...hmlHosts,
  ...releaseCandidateHosts,
  'agros.aqila.com.br', // Agros Produção
  'comercialagro1.aqila.com.br', // ComercialAgro1 - AQILA_DEMONSTRACAO
  'comercial.aqila.com.br', // ComercialAgro1
];

const allowedHostsForRelatorioVisitasV2 = [
  ...hmlHosts,
  ...releaseCandidateHosts,
  'agros.aqila.com.br', // Agros Produção
  'assessoria.aqila.com.br', // Agros Assesoria
  'agroentrerios.aqila.com.br', // Agro Entre Rios Ltda
  'partner.aqila.com.br', // PARTNER PLANEJAMENTO AGROPECUÁRIO - AMAMBAI\MS
  'agroservice.aqila.com.br', // JULIANO BRITO - JA DE BRITO E CIA LTDA - PRIMAVERA DO LESTE\MT
  'cpa.aqila.com.br', // CPA - CONSULTORIA E PLANEJAMENTO EM AGRONEGÓCIO - DOURADOS\MS
  'rehagro.aqila.com.br', // REHAGRO- RECURSOS HUMANOS NO AGRONEGOCIO
  'maisagro.aqila.com.br', // LEX SILVA FREIRE
  'terramadre.aqila.com.br', // ERRA MADRE PESQUISAS
  'bragro.aqila.com.br', // BR AGRO LTDA - Tiago Brasil
  'agropecuarianfries.aqila.com.br', // NELVO FRIES
  'verdeouro.aqila.com.br', // GERALDO DE SOUZA DUARTE JUNIOR
  'evidenciaagricola.aqila.com.br', // MARCELO PEDRO DE MORAES - EVIDENCIA AGRICOLA
  'evoterra.aqila.com.br', // EVOTERRA CONSULTORIA AGRONOMICA
  'agrofutura.aqila.com.br', // AGROFUTURA COMERCIO REPRESENTAǃO DE INSUMOS AGRIC
  'alianca.aqila.com.br', // ALIANÇA AGROCONSULTORIA LTDA
];

// Hotfixes temporários.
// Tudo virará "feature flag" na WEM-1862

export const enableV2Menu =
  // eslint-disable-next-line no-restricted-globals
  allowedHostsForV2.includes(location.host) || isLocalDevelopment;

export const enableRelatorioVisitasV2 =
  // eslint-disable-next-line no-restricted-globals
  allowedHostsForRelatorioVisitasV2.includes(location.host) ||
  isLocalDevelopment;
